import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API } from '@configs/api.config';

@Injectable({
  providedIn: 'root'
})
export class VehicleStatusService {
  constructor(private httpClient: HttpClient) {}

  getVehicleStatus(vehicleIds: string[], orgId: string): Observable<any> {
    const url = `${API.jpm.getVehiclesWithJobs}`;

    const endDate = new Date();
    const startDate = new Date(endDate.getTime() - 60000); // Subtract 1 minute

    const requestBody = {
      orgId,
      operationId: '',
      vehicleIds,
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString()
    };

    return this.httpClient.post(url, requestBody);
  }

  /**
   * The subset of `vehicleIds` that are on a job right now, per the Jpm's own started/not-completed
   * flags. Prefer this over getVehicleStatus: that one derives activity from resourceLogs completion
   * timestamps and flags idle vehicles as busy.
   *
   * No date range - the question is about the present, not a window.
   */
  getVehiclesOnActiveJobs(vehicleIds: string[], orgId: string): Observable<string[]> {
    const url = `${API.jpm.getVehiclesWithActiveJobs}`;
    return this.httpClient.post<string[]>(url, { orgId, vehicleIds });
  }
}
